import React from 'react';

interface ILogoProps {
  className?: string;
  theme?: LOGO_THEME;
}

export enum LOGO_THEME {
  WHITE = 'white',
  BLACK = 'black',
  GREY = 'grey',
}

const Logo = (props: ILogoProps) => {
  const { className, theme = LOGO_THEME.WHITE } = props;

  const getLogo = () => {
    switch (theme) {
      case LOGO_THEME.WHITE:
        return 'SKIDATA_WHITE.png';
      case LOGO_THEME.BLACK:
        return 'SKIDATA_BLACK.png';
      case LOGO_THEME.GREY:
        return 'SKIDATA_Strong.png';
      default:
        return 'SKIDATA_WHITE.png';
    }
  };

  return (
    <span>
      <img src={'assets/' + getLogo()} alt="logo" className={className} />
    </span>
  );
};

export default Logo;
